import { Col, Row } from "reactstrap";
import { H6, Image, LI, P, UL } from "../../../../../AbstractElements";
import { CommentSectionProps } from "../../../../../Types/MiscellaneousType";
import { dynamicImage } from "../../../../../Utils";

const CommentSection: React.FC<CommentSectionProps> = ({ socialComment, colClass, item }) => {
  return (
    <div className="d-flex align-self-start">
      <Image className="align-self-start" src={dynamicImage(`blog/${item.src}`)} alt="Generic placeholder image" />
      <div className="flex-grow-1">
        <Row>
          <div className={colClass}>
            <H6 className="mt-0">
              {item.name}
              <span>{"(Designer)"}</span>
            </H6>
          </div>
          {socialComment && (
            <Col md="8" className="xl-100">
              <UL className="flex-row comment-social float-start float-md-end learning-comment">
                <LI><i className="icofont icofont-thumbs-up"></i>{"02 Hits"}</LI>
                <LI><i className="icofont icofont-ui-chat"></i>{"598 Comments"}</LI>
              </UL>
            </Col>
          )}
        </Row>
        <P>{item.paragraph}</P>
      </div>
    </div>
  );
};
export default CommentSection;
